import { useState, useEffect } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

const useSidebar = () => {
  const isMobile = useMediaQuery('(max-width: 639.95px)')
  const isCompact = useMediaQuery('(max-width: 1439.95px)')
  const [compactExpanded, setCompactExpanded] = useState(false)
  const [preferredExpanded, setIsExpanded] = useState(() => {
    const storedIsExpanded = localStorage.getItem('isExpanded')
    return storedIsExpanded ? storedIsExpanded === 'true' : true
  })

  const [isPinned, setIsPinned] = useState(() => localStorage.getItem('isPinned') === 'true')
  const isExpanded = !isMobile && (isPinned || (isCompact ? compactExpanded : preferredExpanded))

  useEffect(() => {
    setCompactExpanded(false)
  }, [isCompact])

  const toggleSidebar = () => {
    if (!isPinned && !isMobile) {
      if (isCompact) setCompactExpanded(prev => !prev)
      else setIsExpanded(prev => !prev)
    }
  }

  const togglePinSidebar = () => {
    const newIsPinned = !isPinned
    setIsPinned(newIsPinned)
    localStorage.setItem('isPinned', newIsPinned)
    if (newIsPinned) {
      setIsExpanded(true)
    }
    setCompactExpanded(newIsPinned)
  }

  useEffect(() => {
    localStorage.setItem('isExpanded', preferredExpanded)
  }, [preferredExpanded])

  return {
    isExpanded,
    isPinned,
    isMobile,
    toggleSidebar,
    togglePinSidebar,
  }
}

export default useSidebar
